"use strict";

var _objectSpread = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHash = getHash;
exports.createCurve = createCurve;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const hmac_1 = require("@noble/hashes/hmac");
const utils_1 = require("@noble/hashes/utils");
const weierstrass_js_1 = require("./abstract/weierstrass.js");
// connects noble-curves to noble-hashes
function getHash(hash) {
  return {
    hash,
    hmac: function (key) {
      for (var _len = arguments.length, msgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        msgs[_key - 1] = arguments[_key];
      }
      return (0, hmac_1.hmac)(hash, key, (0, utils_1.concatBytes)(...msgs));
    },
    randomBytes: utils_1.randomBytes
  };
}
function createCurve(curveDef, defHash) {
  const create = hash => (0, weierstrass_js_1.weierstrass)(_objectSpread(_objectSpread({}, curveDef), getHash(hash)));
  return Object.freeze(_objectSpread(_objectSpread({}, create(defHash)), {}, {
    create
  }));
}
//# sourceMappingURL=_shortw_utils.js.map